<template>
  <nav>
    <v-btn
      outlined
      elevation="0"
      class="rounded-xxl text-none mr-8 px-4 my-2"
      @click="goBack"
    >
      {{ $t('cancel') }}
    </v-btn>
    <v-btn
      data-testid="submit-button"
      type="submit"
      :disabled="loading"
      color="darktext"
      :class="!disabled?'disabled-submit':' submit'"
      class="rounded-xxl text-none white--text px-4 my-2"
      @click="proceedSubmit"
    >
      {{ $t(nextButtonText) }}<v-icon >mdi-chevron-right</v-icon>
    </v-btn>
  </nav>
</template>

<script>

export default {

    props: {
        nextButtonText: {
          type: String,
          default: ''
        },
        loading: Boolean,
        cancelButtonLink: {
          type: String,
          default: '/'
        },
    },
    data(){
      return{
        disabled:false,
        }
    },
    methods:{
        goBack(){
            this.$router.push({path: this.cancelButtonLink})
        },
        proceedSubmit(){
            this.$emit('proceedSubmit')
        }
    }
}
</script>
